import apiConnection from '$app/plugins/api-connection'

// STATE
const state = {
  pastEvents: [],
  onDeckEvent: ''
}

// MUTATIONS
const mutations = {
  setPastEvents(state, pastEvents) {
    state.pastEvents = pastEvents
  },
  setOnDeckEvent(state, onDeckEvent) {
    state.onDeckEvent = onDeckEvent
  }
}

// ACTIONS
const actions = ({
  getPastEvents({ commit }) {
    return new Promise((resolve, reject) => {
      apiConnection.get('api/arrp/GetPastEvents').then(response => {
        commit('setPastEvents', response.data);
        resolve();
      }).catch(reject);
    });
  },
  getOnDeckEvent({ commit }) {
    return new Promise((resolve, reject) => {
      apiConnection.get('api/arrp/GetOnDeckEvent').then(response => {
        commit('setOnDeckEvent', response.data)
        resolve();
      }).catch(reject);
    });
  }
})

// GETTERS
const getters = {
  getOnDeckEvent: (state) => state.onDeckEvent,
  getPastEvents: (state) => state.pastEvents
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
